import { Grid2, Paper, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import { InternalCodeDrawer } from '../../../Components/Dialog/variants/internal-code/internal-code-dialog.component';
import { SeoFormDrawer } from '../../../Components/Drawer/variants/seo-form/seo-form-drawer.component';
import { VariantsListDrawer } from '../../../Components/Drawer/variants/variants-list/variants-list-drawer.component';
import { ListServiceInfoOrdersUseCase } from '../../../Usecase/ServicesInfo/list-service-info-usecase';
import { useCreateStocks } from './create-stocks-hook';

import { Can } from '../../../Components/Can';
import { Radio } from '../../../Components/Form/Radio/radio-input.component';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { ListCategoriesUseCase } from '../../../Usecase/Categories/list-categories-usecase';
import { ShowProductUseCase } from '../../../Usecase/Products/show-product-usecase';
import { CreateStockUseCase } from '../../../Usecase/Stocks/create-stocks-usecase';
import { ListMangerStocksUseCase } from '../../../Usecase/Stocks/list-manager-stocks-usecase';



  interface IStocksFormProps {
    createStockUseCase: CreateStockUseCase
    listMangerStocksUseCase: ListMangerStocksUseCase
    listServiceInfoOrdersUseCase: ListServiceInfoOrdersUseCase
    showProductUseCase: ShowProductUseCase
    listCategoriesUseCase: ListCategoriesUseCase
  }
const StocksForm : FC<IStocksFormProps> = ({ createStockUseCase, listMangerStocksUseCase, listServiceInfoOrdersUseCase, showProductUseCase, listCategoriesUseCase }) => {
   
    const theme = useTheme()
    const navigate = useNavigate()
   

    const { control, errors, handleAction, handleSubmit, loading, register,  handleSelectCategories, showCategoriesModal, showSEOModal, images, internalCode,  setInternalCode, setShowCategoriesModal, setShowCubageModal, setShowInternalCode, setShowSEOModal, setShowVariationsModal, setVariations, showCubageModal, showInternalCode, showVariationsModal, cubagesList, variations,  categories, setCategories, dragAndDropRef,  stocksServicesOptions, cubagesSelected, storeTypeOptions, categoriesSelected, data, product, operationTypeOptions, movimentationStockName } = useCreateStocks({
      createStockUseCase,
      listMangerStocksUseCase,
      listServiceInfoOrdersUseCase,
      showProductUseCase,
      listCategoriesUseCase
    })

    // useEffect(() => {
    //   listProducts()
    // }, [])

    return (
      <Can permissions={['menu:stocks:manage']}>
        <BaseScreen>
            <SeoFormDrawer handleSelect={e => {}} open={showSEOModal} title='Tags, Marca e SEO' onToggle={() => setShowSEOModal(prev => !prev)} subTitle='Cadastre os conteúdos de SEO para otimizar suas buscas.' containerStyle={{ width: '540px' }} />
{/*             
            <InternalCodeDrawer  handleSelect={e => setInternalCode(e)} open={showInternalCode}  onToggle={() => setShowInternalCode(prev => !prev)} title='Código Interno' code={internalCode.maskCode}  /> */}

            {/* <VariantsListDrawer handleSelect={e => {}} open={showVariationsModal} title='Variações' onToggle={() => setShowVariationsModal(prev => !prev)} subTitle='Cadastre uma nova variação' /> */}

   
            <Paper>
                <BaseContentPage 
                    title={`Movimentação de Estoque - ${product?.name}`}
                    breadcrumb={[{ title: 'Produtos', link: "/stocks-list"}, { title: 'Novo Produto'}]}
                >

                  {loading ? <Loader /> : (
                    <>
                       <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                        <Grid2 size={4}>
                   
                         
                                <Radio
                                    label="Escolha uma opção"
                                    labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                                    name="store"
                                    control={control}
                                    options={storeTypeOptions}
                                    error={!!errors.store}
                                    helperText={errors?.store?.message}
                                    
                                    defaultValue={data?.store}
                                />   
                     
                        </Grid2>

                         <Grid2 size={4}>
                   
                         
                                <Radio
                                    label="Tipo de movimentação"
                                    labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                                    name="action"
                                    control={control}
                                    options={operationTypeOptions}
                                    error={!!errors.action}
                                    helperText={errors?.action?.message}
                                    
                                    defaultValue={data?.store}
                                />   
                     
                        </Grid2>

                        <Grid2 size={4}>
                          <Typography sx={{fontSize: '19px', fontWeight: '600', marginBottom: '10px'}}>Estoque</Typography>
                          <SelectComponent
                            options={movimentationStockName}
                            label=""
                            name="stock"
                            control={control}
                            placeholder="Selecione o Estoque"
                            error={!!errors.stock}
                            helperText={errors.stock?.message}
                          />
                      </Grid2>

                      <Grid2 size={4}>
                        <Typography sx={{fontSize: '19px', fontWeight: '600', marginBottom: '10px'}}>Quantidade</Typography>
                            <Input
                                  label="Quantidade"
                                  placeholder="Preencha a quantidade"
                                  error={!!errors.howMany}
                                  helperText={errors.howMany?.message}
                                  type='number'
                                  {...register('howMany')}
                              />
                      </Grid2>

                      <Grid2 size={4}>
                        <Typography sx={{fontSize: '19px', fontWeight: '600', marginBottom: '10px'}}>Motivo</Typography>
                            <Input
                                  label="Motivo"
                                  placeholder="Preencha o motivo"
                                  error={!!errors.description}
                                  helperText={errors.description?.message}
                              
                                  {...register('description')}
                              />
                      </Grid2>



                        {/* <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na EMPO - B2B"
                                name="createOnNSEmpo"
                                control={control}

                            />
                        </Grid2>

                        <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na Papello - B2C"
                                name="createOnNSPapello"
                                control={control}
                              
                            />
                        </Grid2> */}








                        {/* <Typography sx={{fontSize: '19px', fontWeight: '600'}}>ERP (Omie) - Configurações</Typography>

                        <Grid2 size={12} container sx={{
                          width: '100%',
                          padding: '20px',
                          border: '2px dashed #ccc',
                          borderRadius: '8px',
                          marginTop: -4
                        }}>

                        <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na Empo"
                                name="createOnOmie"
                                control={control}

                            />
                        </Grid2>

                        <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na Papello"
                                name="createOnNuvemShop"
                                control={control}
                              
                            />
                        </Grid2>

                            
                        </Grid2> */}

                        
                        <>
                         

                

                        

                        
                        <Grid2 size={12}>
                          <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                              SALVAR
                          </Button>
                          </Grid2>
                        </>

                      



                        </Grid2>
                    </>
                  )}

                 
                   
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { StocksForm };
